import type { PriceObservation } from "../../types/receipt";
import { money } from "../../lib/finance";

export default function TransactionTrackedPrices({ prices }: { prices: PriceObservation[] }) {
  return <>
          {prices.length > 0 && (
            <section className="linked-prices" aria-label="Tracked prices">
              <div className="linked-prices-head">
                <h3>Tracked prices</h3>
                <span className="linked-prices-count">{prices.length}</span>
              </div>
              <div className="linked-price-list">
                {prices.map((price) => {
                  const groupLabel =
                    price.group &&
                    price.group.trim().toLowerCase() !== price.name.trim().toLowerCase()
                      ? price.group
                      : "";
                  const qtyLabel =
                    price.measure !== null && price.unit
                      ? `${price.measure} ${price.unit}`
                      : "";
                  const meta = [
                    price.brand,
                    groupLabel,
                    price.pack,
                    qtyLabel && qtyLabel !== price.pack ? qtyLabel : "",
                  ]
                    .filter(Boolean)
                    .join(" · ");
                  return (
                    <article className="linked-price-row" key={price.observationId}>
                      <div className="linked-price-copy">
                        <strong>{price.name}</strong>
                        {meta && <small>{meta}</small>}
                      </div>
                      <div className="linked-price-amount">
                        <b>{money(price.total, price.currency)}</b>
                        {price.unitPrice !== null && (
                          <small>
                            {money(price.unitPrice, price.currency)} / {price.unit}
                          </small>
                        )}
                      </div>
                    </article>
                  );
                })}
              </div>
            </section>
          )}
  </>;
}
